<template>
    <div class="row">

        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">{{ tableTitle }}</h3>
            </div>
            <table class="table table-bordered table-striped">
                <thead>
                <tr>
                    <th class="row-actions row-actions-2-btn">&nbsp;</th>
                    <th>Coach</th>
                    <th>Set Name</th>
                    <th>Distance</th>
                    <th>Time</th>
                    <th>Strokes</th>
                    <th>Type</th>
                    <th>Intensity</th>
                    <th>Equipment</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(trainingSet,index) in trainingSets" v-if="trainingSets.length > 0">
                    <td class="row-actions row-actions-2-btn">
                        <button class="btn btn-danger btn-sm" @click="handleDelete(index, trainingSet)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
                        <!-- <button class="btn btn-primary btn-sm" @click="handleEdit(index, group)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> -->
                        <button class="btn btn-primary btn-sm" @click="handleEdit(index, trainingSet)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button>
                    </td>
                    <td>
                        {{ trainingSet.owner != null ? trainingSet.owner.name : '' }}
                    </td>
                    <td>
                        {{ trainingSet.training_set_name }}
                    </td>
                    <td>
                        {{ trainingSet.distance }}
                    </td>
                    <td>
                        {{ trainingSet.type }}
                    </td>
                    <td>
                        {{ trainingSet.time }}
                    </td>
                    <td>
                        {{ trainingSet.strokes }}
                    </td>
                    <td>
                        {{ trainingSet.intensity }}
                    </td>
                    <td>
                        {{ trainingSet.equipment }}
                    </td>
                </tr>
                <tr v-if="trainingSets.length == 0">
                    <td colspan="9" align="center">
                        <strong>There are no training sets to display</strong>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>


    </div>


</template>



<script>

    import { Loading } from 'element-ui';
    import lang from 'element-ui/lib/locale/lang/en';
    import locale from 'element-ui/lib/locale';
    locale.use(lang);

    export default {
        props: {
            title: {
                type: String,
                default: "Training Sets"
            },
            can_manage: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                trainingSets: [],
                tableTitle: this.title,
                canManage: this.can_manage,
                editingIndex: -1,
                editingTrainingSet: {},
            }
        },
        computed: {
        },
        mounted() {
            this.debug('Training Set component mounted.');
            this.loadTrainingSets();
        },
        methods: {

            handleDelete(index, record) {
                this.debug('Deleting record: ' + record.id);
                axios.delete(`/api/v1/training_set/${record.id}`).then((response) => {
                    // this.loadingInstance.close();
                    this.debug(response.data);
                    this.loadTrainingSets();
                    this.$message({message: 'The training set has been deleted.', type: 'success'});
                }).catch((error) => {
                    // this.loadingInstance.close();
                    this.$message({message: 'There was a problem deleting the training set.', type: 'error'});
                });
            },
            handleEdit(index, record) {
                this.debug('Editing record: ' + record.id);
                this.debug('Index: ' + index)
                this.debug(record);
                this.$emit('edit-training-set', record.id, record);
            },
            loadTrainingSets() {
                this.debug('loadTrainingSets()');
                axios.get(`/api/v1/training_sets`)
                    .then(response => {
                        this.trainingSets = response.data;
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem fetching training sets.', type: 'error'});
                        console.log(error);
                    });
            },
            debug(message) {
                console.log('TrainingSetList: ' + message);
            }
        }
    }
</script>
